<template>
  <span alt="online" title="online">({{ count }})</span>
</template>

<script>
import * as API from '../parts/YoNetwork/YoNetwork.js'
export default {
  props: {
    roomID: {}
  },
  data () {
    return {
      count: 0
    }
  },
  mounted () {
    API.onChangeOnlineCounter({
      roomID: this.roomID,
      onChange: (data) => {
        this.count = data.kClients.length
      }
    })
    API.checkOnline({ roomID: this.roomID })
  }
}
</script>

<style>

</style>
